import AppContext from "AppContext";
import { useContext, useEffect, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import cruzamentoService from "services/CruzamentoService";

export default function ModalDetalhesCruzamento({ cruzamento, onClosed, onClickCamera, onClickCriarOS }) {
  const [cameras, setCameras] = useState([])
  const { state } = useContext(AppContext)

  const podeLancarOS = (state?.user?.acoes || []).includes('os.gerenciar')

  useEffect(() => {
    setCameras([])
    if (cruzamento) {
      cruzamentoService.getCameras(cruzamento.id).then(res => {
        if (res.success) {
          setCameras(res.data)
        }
      })
    }
  }, [cruzamento])

  return (
    <Modal
      isOpen={!!cruzamento}
      toggle={onClosed}
      onClosed={onClosed}
    >
      <ModalBody className="d-flex flex-column" style={{ rowGap: 10 }}>
        <h1>Informações do Cruzamento</h1>
        {cruzamento && (
          <>
            <div><strong>Cruzamento:</strong> {cruzamento.numero}</div>
            <div><strong>Endereço:</strong> {cruzamento.endereco}</div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: 5,
            }}>
              {cameras.map(camera => (
                <div key={camera.id}>
                  <Button
                    color="primary"
                    outline
                    block
                    onClick={() => onClickCamera && onClickCamera(camera)}
                  >
                    {camera.codigo}
                  </Button>
                </div>
              ))}
            </div>
            {podeLancarOS && (
              <Button
                color="primary"
                block
                className="mt-4"
                onClick={() => onClickCriarOS && onClickCriarOS(cruzamento)}
              >
                Criar Ordem de Serviço
              </Button>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  )
}